import styled from 'styled-components';

import {
  fontFamilySecondary,
  colorBlack900,
  colorGrey400,
  colorWhite2,
  mediaQueryMobileLargeMin,
  colorWhite,
  colorPrimaryLighten95,
  colorPrimary200,
  colorPrimary,
  colorAccent50,
  mediaQueryDesktopMin,
} from 'styles';

import Icon from 'components/commons/Icon';
import { Wrapper as SectionWrapper } from 'components/CurrencyExchangeTable/styles';
import { WatermarkedTableContainer } from 'components/WatermarkedTableContainer';
import { TABLE_WATERMARK_POSITIONS } from 'constants/tableWatermark';
import { H2, ParagraphSmall, Paragraph } from 'components/Typography';
import { CommentsLink } from 'components/ExchangeDiscussion/styles';

export const Wrapper = styled(SectionWrapper)`
  margin-top: 8px;

  @media all and ${mediaQueryMobileLargeMin} {
    margin-top: 16px;
  }
`;

export const IconWatch = styled(Icon)`
  margin-right: 4px;
  margin-top: -1px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  font-family: ${fontFamilySecondary};
  margin-bottom: 15px;

  & > ul {
    margin-left: unset;
  }

  & > ul button svg {
    margin-top: 1px;
  }

  @media all and ${mediaQueryMobileLargeMin} {
    flex-direction: row;

    & > ul {
      margin-left: auto;
      width: unset;
    }
  }
`;

export const Title = styled(H2)`
  color: ${colorBlack900};
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  margin-bottom: 16px;
  font-family: ${fontFamilySecondary};

  @media all and ${mediaQueryMobileLargeMin} {
    font-size: 20px;
    line-height: 28px;
    margin-bottom: 0;
  }
`;

export const TableHead = styled.thead`
  & tr {
    box-shadow: none;

    &:last-child {
      display: none;
      @media all and ${mediaQueryMobileLargeMin} {
        display: table-row;
      }
    }
  }
`;

export const TableTitle = styled.th`
  color: ${colorGrey400};
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  width: ${({ id }) => (id === 'updated' ? 0 : '33.333%')};

  &:nth-child(3),
  &:nth-child(2) {
    div {
      text-align: right;

      @media all and ${mediaQueryMobileLargeMin} {
        text-align: center;
      }
    }
  }
`;

export const TableTitleContent = styled.div`
  display: flex;
  padding: 16px 8px;
  color: ${({ selected }) => selected && colorBlack900};
  justify-content: ${({ align }) =>
    align === 'left' ? 'flex-start' : 'center'};
  align-items: center;

  ${({ name }) => {
    if (name === 'updated') {
      return `
        display: none;
        justify-content: flex-end;
        @media all and ${mediaQueryMobileLargeMin}{
          display: flex;          
        }
      `;
    }
    return ``;
  }}

  @media all and ${mediaQueryMobileLargeMin}{
    padding: 8px 16px;
  }
`;

export const TableSubTitleContent = styled(TableTitleContent)`
  padding: 0 12px 12px;
`;

export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  border: 1px solid #cacccb;
  border-radius: 2px;
  padding: 6px 15px;
  margin-bottom: 16px;
`;

export const SearchInput = styled.input`
  width: 100%;
  background: #ffffff;
  border: none;
  font-size: 16px;
  line-height: 24px;

  @media all and ${mediaQueryDesktopMin} {
    font-size: 14px;
  }

  &:focus {
    outline: none;
  }
`;

export const BanksListWrapper = styled(WatermarkedTableContainer).attrs(() => ({
  watermarkLeft: TABLE_WATERMARK_POSITIONS.banks.left,
  watermarkLeftMobile: TABLE_WATERMARK_POSITIONS.banks.leftMobile,
}))`
  width: 100%;
`;

export const BanksList = styled.table`
  width: 100%;
  table-layout: fixed;
`;

export const Row = styled.tr`
  box-shadow: inset 0 1px 0 #e6e6e6;
  display: flex;
  flex-wrap: wrap;

  &:nth-of-type(odd) {
    background-color: #fbfbfb;
  }

  & td:last-child {
    width: 100%;
    justify-content: flex-end;
  }

  @media all and ${mediaQueryMobileLargeMin} {
    display: table-row;
  }

  ${({ commercialPlacement }) => {
    if (commercialPlacement) {
      return `
            background-color: #FEF9E9 !important;
            `;
    }

    return ``;
  }};
`;

export const Column = styled.td`
  padding: 12px 8px;
  width: 33.3333%;

  @media all and ${mediaQueryMobileLargeMin} {
    padding: 16px;
    width: auto;
  }
`;

export const ColumnUpdate = styled(Column)`
  padding: 0 8px 12px;
  margin-top: -16px;

  @media all and ${mediaQueryMobileLargeMin} {
    padding: 16px;
    margin-top: 0;
  }
`;
export const BankColumn = styled.div`
  display: flex;
  flex-direction: column;

  @media all and ${mediaQueryMobileLargeMin} {
    flex-direction: row;
    align-items: center;
  }
`;
export const Curr = styled(Column)`
  font-size: 18px;
  color: ${colorBlack900};
  line-height: 21px;
  font-weight: 900;
`;

export const BankLink = styled.a`
  font-size: 14px;
  line-height: 18px;
  color: ${colorWhite2};
`;

export const Update = styled.div`
  color: ${colorGrey400};
  font-size: 13px;
  line-height: 19px;
  white-space: nowrap;
  justify-content: flex-end;
  align-items: center;
  display: flex;
`;

export const CurrContent = styled.div`
  display: flex;
  font-size: 14px;
  line-height: 16px;
  justify-content: flex-end;
  height: 100%;
  align-items: center;

  @media all and ${mediaQueryMobileLargeMin} {
    font-size: 16px;
    line-height: 18px;
    justify-content: center;
  }
`;

export const DiffWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  height: 14px;

  @media all and ${mediaQueryMobileLargeMin} {
    height: unset;
  }
`;

export const Diff = styled(ParagraphSmall)`
  font-weight: normal;
  margin-top: 7px;
`;

export const IconWrapper = styled.div`
  margin: 0 2px 0 4px;
  padding-top: 2px;
`;

export const AllBanks = styled(CommentsLink)`
  margin-top: 0;
  order: 2;

  @media all and ${mediaQueryMobileLargeMin} {
    order: 1;
  }
`;

export const Source = styled(Paragraph)`
  color: ${colorGrey400};
  line-height: 16px;
  order: 1;

  @media all and ${mediaQueryMobileLargeMin} {
    order: 2;
  }
`;

export const Disclaimer = styled.div`
  order: 3;
  display: flex;
  gap: 12px;
  background-color: ${colorAccent50};
  padding: 16px;
  font-size: 14px;
  line-height: 18px;

  @media all and ${mediaQueryMobileLargeMin} {
    width: 100%;
  }
`;

export const DisclaimerIcon = styled(Icon)`
  flex-shrink: 0;
`;

export const Bottom = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-shadow: inset 0px 1px 0px #e5e5e5;
  padding-top: 18px;

  @media all and ${mediaQueryMobileLargeMin} {
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
  }
`;

export const BankLogo = styled.img`
  display: inline-block;
  max-width: 24px;
  max-height: 24px;
  object-fit: contain;
  margin-bottom: 8px;

  @media all and ${mediaQueryMobileLargeMin} {
    margin-right: 10px;
    margin-bottom: 0;
  }
`;
export const MobileSort = styled.button`
  display: flex;
  border: 1px solid #cacccb;
  border-radius: 8px;
  padding: 7px 16px;
  align-items: center;
  outline: none;
  background-color: ${colorWhite};
  width: 100%;
  margin-bottom: 12px;
  color: ${colorBlack900};
  min-height: 48px;
`;

export const ModalSortOptions = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  position: relative;
  width: 100%;
  overflow-y: auto;
  background: ${colorWhite};
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.24);
  border-radius: 4px;
  margin-top: -8px;
`;

export const ModalSortOptionsTitle = styled.div`
  font-family: ${fontFamilySecondary};
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: ${colorGrey400};
  margin-bottom: 8px;
`;
export const ModalSortOptionsList = styled.div`
  margin: 0 -16px;
  width: calc(100% + 32px);
`;

export const MobileSortContent = styled.div`
  text-align: left;
  font-size: 13px;
  line-height: 16px;
  margin: 0 16px;
  letter-spacing: 0.01em;
`;

export const MobileSortOption = styled.div`
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.03em;
  color: ${colorGrey400};
`;

export const IconDown = styled.div`
  width: 0;
  height: 0;
  border-top: 5px solid ${colorBlack900};
  border-right: 5px solid transparent;
  border-left: 5px solid transparent;
  margin-left: auto;
  transform: ${({ isOpen }) => isOpen && 'rotate(180deg)'};
`;

export const ModalSortTabWrapper = styled.div`
  display: flex;
  margin: 4px 0 32px;
`;

export const MobileRow = styled.div`
  @media all and ${mediaQueryMobileLargeMin} {
    display: none;
  }
`;

export const ModalSortTab = styled.button`
  height: 40px;
  line-height: 39px;
  border: 1px solid
    ${({ selected }) => (selected ? colorPrimary200 : '#cacccb')};
  flex: 1;
  font-size: 14px;
  background-color: ${({ selected }) =>
    selected ? colorPrimaryLighten95 : colorWhite};
  position: relative;
  z-index: ${({ selected }) => selected && 1};
  display: flex;
  justify-content: center;
  color: ${({ selected }) => (selected ? colorPrimary : colorBlack900)};

  &::before {
    display: ${({ selected }) => (selected ? 'block' : 'none')};
    margin-right: 4px;
    border-color: ${colorPrimary200};
    content: '';
    position: relative;
    left: -6px;
    top: 9px;
    width: 6px;
    height: 10px;
    border-width: 0 2px 2px 0;
    border-style: solid;
    transform-origin: bottom left;
    transform: rotate(45deg);
  }

  &:first-child {
    border-radius: 4px 0 0 4px;
  }

  &:last-child {
    border-radius: 0 4px 4px 0;
    margin-left: -1px;
  }
`;
